import {
  createTableNavigationInput,
  type SharedEventLoop,
  type TableNavigationAdapter,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { getExperimentValue } from '@canvas/client-feature-flags';

import { type SelectionInputFeature, SelectionFeatureKeys } from '../../features/types';

export interface TableNavigationKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  adapter: TableNavigationAdapter;
}

/**
 * Registers table grid navigation behind the keyboard accessibility experiment.
 *
 * This remains table-layout scoped because the selections package needs an app
 * adapter for visible row and field order.
 */
export function createTableNavigationKeyboardInputFeature(
  deps: TableNavigationKeyboardInputFeatureDeps
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_NAVIGATION_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) => {
      if (ctx.layoutType !== DatabaseLayoutType.TABLE) {
        return false;
      }

      return (
        getExperimentValue('databasesKeyboardA11y', 'isEnabled', {
          fireExperimentExposure: false,
        }) === true
      );
    },
    factory: (machine) =>
      createTableNavigationInput(machine, deps.sharedLoop, deps.adapter),
  };
}
